import { VideoRecordStart } from '../../../../../../../api/videoRec/VideoRecStart';
import { VideoRecordStartArray } from '../../../../../../../api/videoRec/videoRecArray/VideoRecStartArray';
import { useAuthStore } from '../../../../../../../store/auth/auth';
import { VideoRecordEndArray } from '../../../../../../../api/videoRec/videoRecArray/VideoRecStopArray';
import { VideoRecordEnd } from '../../../../../../../api/videoRec/VideoRecStop';
import { AudioRecordStart } from '../audioRec/AudioRecStart';
import { AudioRecStartArray } from '../audioRec/audioRecArray/AudioRecStartArray';
import { AudioRecordEnd } from '../audioRec/AudioRecStop';
import { AudioRecStopArray } from '../audioRec/audioRecArray/AudioRecStopArray';
import { PhotoRecord } from '../../../../../../../api/fotoRec/PhotoRec';
import { PhotoRecordArray } from '../../../../../../../api/fotoRec/photoRecArray/PhotoRecArray';
import { useMemo } from 'react';
import { Device } from '../../../../../../../types/Device';

// Базовые функции API
export const startVideoRecording = async (deviceUIDs: string[]) => {
    const { SmartDVRToken, user } = useAuthStore.getState();
    if (!SmartDVRToken || !user?.login) {
        throw new Error('Missing authentication data');
    }

    // Для одного устройства
    if (deviceUIDs.length === 1) {
        const response = await VideoRecordStart(SmartDVRToken, user.login, {
            UID: deviceUIDs[0],
        });
        console.log(response);
        return response;
    }

    // Для нескольких устройств (пакетный запрос)
    const response = VideoRecordStartArray(SmartDVRToken, user.login, { UID: deviceUIDs });

    console.log(response);
    return response;
};

export const stopVideoRecording = async (deviceUIDs: string[]) => {
    const { SmartDVRToken, user } = useAuthStore.getState();
    if (!SmartDVRToken || !user?.login) {
        throw new Error('Missing authentication data');
    }

    if (deviceUIDs.length === 1) {
        const response = await VideoRecordEnd(SmartDVRToken, user.login, {
            UID: deviceUIDs[0],
        });
        console.log(response);
        return response;
    }

    const response = VideoRecordEndArray(SmartDVRToken, user.login, { UID: deviceUIDs });
    console.log(response);
    return response;
};

export const startAudioRecording = async (deviceUIDs: string[]) => {
    const { SmartDVRToken, user } = useAuthStore.getState();
    if (!SmartDVRToken || !user?.login) {
        throw new Error('Missing authentication data');
    }

    if (deviceUIDs.length === 1) {
        const response = await AudioRecordStart(SmartDVRToken, user.login, {
            UID: deviceUIDs[0],
        });
        console.log(response);
        return response;
    }

    const response = AudioRecStartArray(SmartDVRToken, user.login, { UID: deviceUIDs });
    console.log(response);

    return response;
};

export const stopAudioRecording = async (deviceUIDs: string[]) => {
    const { SmartDVRToken, user } = useAuthStore.getState();
    if (!SmartDVRToken || !user?.login) {
        throw new Error('Missing authentication data');
    }

    if (deviceUIDs.length === 1) {
        const response = await AudioRecordEnd(SmartDVRToken, user.login, {
            UID: deviceUIDs[0],
        });
        console.log(response);

        return response;
    }

    const response = AudioRecStopArray(SmartDVRToken, user.login, { UID: deviceUIDs });
    console.log(response);

    return response;
};

export const takePhotos = async (deviceUIDs: string[]) => {
    const { SmartDVRToken, user } = useAuthStore.getState();
    if (!SmartDVRToken || !user?.login) {
        throw new Error('Missing authentication data');
    }

    if (deviceUIDs.length === 1) {
        const response = await PhotoRecord(SmartDVRToken, user.login, {
            UID: deviceUIDs[0],
        });
        console.log(response);

        return response;
    }

    const response = PhotoRecordArray(SmartDVRToken, user.login, { UID: deviceUIDs });
    console.log(response);

    return response;
};
